module.exports = __webpack_public_path__ + "img/temakifrontal.72023e2f.jpg";